import React from 'react'
import View from './view'
import {saveStudyGuideProgress, StudyGuide} from '../../../redux/studyGuides'
import {useAppDispatch} from '../../../redux/configureStore'
import {useAuth} from '../../../components/AuthProvider'
import {getOrganizationCourses} from '../../../redux/courses'

type Props = {
  currentAssetId?: string
  studyGuide?: StudyGuide
  studyDay?: number
  isExpanded: boolean
  onChangeIsExpanded: (value: boolean) => void
}

const AssetsSidenav = ({
  currentAssetId,
  studyGuide,
  studyDay,
  isExpanded,
  onChangeIsExpanded,
}: Props) => {
  const dispatch = useAppDispatch()
  const auth = useAuth()

  const saveProgress = async (globalAssetId: number) => {
    const {type} = await dispatch(
      saveStudyGuideProgress({auth, globalAssetId, studyDay}),
    )

    if (type === saveStudyGuideProgress.fulfilled.type) {
      await dispatch(getOrganizationCourses({auth, keepState: true}))
    }
  }

  return (
    <View
      currentAssetId={currentAssetId}
      studyGuide={studyGuide}
      studyDay={studyDay}
      onSaveProgress={saveProgress}
      isExpanded={isExpanded}
      onChangeIsExpanded={onChangeIsExpanded}
    />
  )
}

export default AssetsSidenav
